// extracted by mini-css-extract-plugin
export default {"dialog":"FullscreenDialogShim_dialog__-SZbt","close":"FullscreenDialogShim_close__GpQeE"};